const set_en = {
  title: 'Create Item Set',
  back: 'Back',
  groupView: 'Group View',
  listView: 'List View',
  widthDepthHeight: 'Width x Depth x Height',
  uncategorized: 'Uncategorized',
  untagged: 'Untagged',
  table: {
    name: 'Name',
    category: 'Category',
    subCategory: 'Sub Category',
    minimumStock: 'Minimum Stock',
  },
  form: {
    title: 'Create New Set',
    editTitle: 'Edit Item Set',
    name: 'Set Name',
    namePlaceholder: 'Enter Set Name',
    tagRequired: 'Tag is required',
    selectedItems: 'Selected Items',
    reset: 'Reset',
    createSet: 'Create Set',
    editSet: 'Edit Set',
    setUpdated: 'Set was updated',
    setCreated: 'Set was created',
    setCreateError: 'Failed to create set',
    setUpdateError: 'Failed to update set',
    noItemsSelected: 'Please select at least one item before creating a set',
    removeItem: 'Remove article',
  },
  delete: {
    title: 'Delete Item Set',
    body: 'Are you sure you want to delete this set?',
    delete: 'Delete',
    cancel: 'Cancel'
  },
  list: {
    title: 'Sets',
    search: 'Search',
    editSet: 'Edit Set',
    deleteSet: 'Delete Set',
    noItems: 'No items found',
  },
  detail: {
    title: 'Item Set Details',
    setName: 'Set Name',
    setItems: 'Set Items',
    close: 'Close',
    edit: 'Edit',
    delete: 'Delete'
  }
}

export default set_en
